<div class="manage-prospect" *ngIf="!loading">
    <div class="manage-prospect-header container-fluid page-container">
        <page-header
            class="page-header"
            [titleText]="this.getBusinessName()"
            [shortBottomPadding]="true"
            backButtonText="Back To Prospects"
            (handleBackButtonClick)="navigateToProspectsPage()"
        >
            <status-pill
                [status]="status"
                [displayValueMap]="statusDisplay"
                [color]="statusColor[status] || processingColor"
                [isSolid]="true"
            ></status-pill>
            <lsq-icon
                *ngIf="!!tooltipText"
                [attr.tabindex]="0"
                [type]="icons.QuestionCircleLight"
                [popoverOnHover]="true"
                [height]="14"
                [width]="14"
                [popover]="tooltipText"
                [popoverPlacement]="tooltipPlacement"
                [popoverTitle]="popoverTitle"
                [color]="color.Slate"
            >
            </lsq-icon>
        </page-header>

        <lsq-button
            class="watchers-button"
            appearance="secondary"
            [size]="'md'"
            [type]="'button'"
            (buttonClick)="showWatchersModal()"
        >
            <lsq-icon
                class="watchers-button-icon"
                [type]="icons.FaEye"
                [color]="color.Black"
                [width]="20"
                [height]="18"
            ></lsq-icon>
            <span class="watchers-button-text"> Watchers ({{ watchersCount() }}) </span>
        </lsq-button>
    </div>
    <div class="container-fluid page-container">
        <tabs [tabsConfig]="tabsConfig$"></tabs>
        <router-outlet></router-outlet>
    </div>
</div>
<div *ngIf="loading">
    <lsq-circle-loader></lsq-circle-loader>
</div>
